import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import LookVideoDialog from '@/components/look-video-dialog.vue';
import TopicModel from '@/components/topic-video-dialog.vue';
import DarkBg from '@/components/dark-bg.vue';
import NoFindZxb from '@/components/no-find-zxb.vue';
import ServiceDialog from './service-dialog.vue';
import { getVideoUrl } from '@/utils/guide-video';
import { getCodeUrlMixins } from '@/utils/getCodeUrlMixin.js';
import { studyCardList, wrongInfo, practiceInfo, serviceInfo } from './rightCardData';
import { getConfigurateList, getGuideModules as _getGuideModules, getExpVideo } from '@/api/home';
export default {
  name: 'RightContent',
  components: {
    LookVideoDialog: LookVideoDialog,
    TopicModel: TopicModel,
    DarkBg: DarkBg,
    ServiceDialog: ServiceDialog
  },
  mixins: [getCodeUrlMixins],
  data: function data() {
    return {
      showServiceDialog: false,
      showVideoDialog: false,
      dialogUrl: '',
      dialogTitle: '',
      topicVisible: false,
      iframeTitle: '',
      iframeUrl: '',
      iframeResult: '',
      activeIndex: 0,
      isLastPage: false,
      preciousType: -1,
      pageNum: -1,
      modules: [],
      // 指引卡片
      pageModules: [],
      introduceVideoInfo: {},
      volumeNameList: ['学习分册', '练习分册', '复习分册', '智能学习系统'],
      intellectVideoList: [] // 智能学习视频

    };
  },
  computed: _objectSpread({}, mapGetters({
    experienceBook: 'experienceBook',
    preciousMessage: 'preciousMessage'
  })),
  watch: {
    'preciousType': function preciousType(val) {
      if (val) {
        this.init();
      }
    },
    'pageNum': function pageNum(val) {
      if (val) {
        this.getGuideModules();
      }
    },
    'expandExperience': function expandExperience(val) {
      if (val) {
        this.init();
      }
    },
    'preciousMessage': function preciousMessage(val) {
      if (val) {
        this.getGuideModules();
      }
    }
  },
  created: function created() {
    this.$bus.$on('toRightMenu', this.getProps); // window.addEventListener('message', (event) => {
    //   if (event?.data?.eventName === 'videoEnd') {
    //     if (this.preciousType === 4 && this.activeIndex < this.intellectVideoList.length - 1) {
    //       this.activeIndex = this.activeIndex + 1
    //       this.videoIndexChange(this.activeIndex)
    //     }
    //   }
    // })
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('toRightMenu');
  },
  methods: {
    getProps: function getProps(props) {
      this.preciousType = (props === null || props === void 0 ? void 0 : props.preciousType) || -1;
      this.pageNum = (props === null || props === void 0 ? void 0 : props.pageNum) || -1;
      this.isLastPage = (props === null || props === void 0 ? void 0 : props.isLastPage) || false;
    },
    init: function init() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$getConfigurate, data, params, _yield$getExpVideo, _data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.preciousType === 4)) {
                  _context.next = 8;
                  break;
                }

                _context.next = 3;
                return getConfigurateList({
                  sceneCode: 'ffhz_exp_01'
                });

              case 3:
                _yield$getConfigurate = _context.sent;
                data = _yield$getConfigurate.data;

                if (data !== null && data !== void 0 && data.length) {
                  _this.intellectVideoList = data;
                  _this.activeIndex = 0;

                  _this.$bus.$emit('videoChange', data[_this.activeIndex]);
                }

                _context.next = 15;
                break;

              case 8:
                // 获取介绍视频
                params = {
                  libraryId: _this.experienceBook.libraryId,
                  preciousType: _this.preciousType
                };
                _context.next = 11;
                return getExpVideo(params);

              case 11:
                _yield$getExpVideo = _context.sent;
                _data = _yield$getExpVideo.data;
                _this.introduceVideoInfo = _data || {};

                if (_this.preciousType === 1 || _this.preciousType === 2) {
                  // 获取指引
                  _this.getGuideModules();
                }

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getGuideModules: function getGuideModules() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, _yield$_getGuideModul, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this2.preciousType === 3 || _this2.preciousType === 4)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                params = {
                  boxId: _this2.experienceBook.boxId || _this2.preciousMessage.boxId,
                  page: _this2.pageNum.toString(),
                  preciousType: _this2.preciousType,
                  isLastPage: _this2.isLastPage,
                  subjectId: _this2.experienceBook.subjectId || _this2.preciousMessage.subject
                };
                _context2.next = 5;
                return _getGuideModules(params);

              case 5:
                _yield$_getGuideModul = _context2.sent;
                data = _yield$_getGuideModul.data;

                _this2.initGuideCard(data === null || data === void 0 ? void 0 : data.modules);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    initGuideCard: function initGuideCard(modules) {
      var _this3 = this;

      if (!modules) {
        this.pageModules = [];
        return;
      }

      if (this.preciousType === 1) {
        // 学习
        var list = modules.map(function (item, index) {
          var cardInfo = studyCardList.find(function (value) {
            return value.type === item.moduleType;
          });
          item = _objectSpread(_objectSpread({}, cardInfo), item);

          if (_this3.isLastPage && index === modules.length - 1) {
            item = _objectSpread(_objectSpread({}, item), wrongInfo);
          }

          return item;
        });
        this.pageModules = list;
      } else {
        // 练习
        var _list = modules.map(function (item) {
          // item.title = practiceInfo.title + item.moduleName
          item = _objectSpread(_objectSpread({}, practiceInfo), item);
          return item;
        });

        if (this.isLastPage) {
          _list.push(serviceInfo);
        }

        this.pageModules = _list;
      }
    },
    toNext: function toNext(item) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, _yield$_this4$getCode, result;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {};

                if (!(item.next === 'video' || item.next === 'answer')) {
                  _context3.next = 16;
                  break;
                }

                params = {
                  page: _this4.pageNum.toString(),
                  subject: _this4.experienceBook.subjectId || _this4.preciousMessage.subject,
                  boxId: _this4.experienceBook.boxId || _this4.preciousMessage.boxId,
                  preciousType: _this4.preciousType,
                  businessId: item.businessId,
                  moduleType: item.moduleType,
                  saveToHistoty: false
                };
                _context3.next = 5;
                return _this4.getCodeTurn(params);

              case 5:
                _yield$_this4$getCode = _context3.sent;
                result = _yield$_this4$getCode.result;
                _this4.code = '';

                if (result) {
                  _context3.next = 11;
                  break;
                }

                _this4.$showModal(NoFindZxb, {}, {
                  noFooter: true,
                  width: '784px',
                  customClass: 'no-find-dialog'
                });

                return _context3.abrupt("return");

              case 11:
                _this4.iframeResult = result;
                _this4.iframeTitle = result.outlineName;
                _this4.topicVisible = !_this4.topicVisible;
                _context3.next = 17;
                break;

              case 16:
                if (item.next === 'wrong') {
                  _this4.$store.dispatch('setExperienceInfos', {
                    preciousType: _this4.preciousType,
                    pageNum: _this4.pageNum
                  });

                  _this4.$router.push({
                    path: '/service',
                    query: {
                      url: item.url + '&userMode=experience'
                    }
                  });
                } else if (item.next === 'service') {
                  _this4.showServiceDialog = true;
                }

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 播放视频
    playVideo: function playVideo() {
      this.dialogUrl = getVideoUrl(this.introduceVideoInfo);
      this.dialogTitle = this.introduceVideoInfo.videoName;
      this.showVideoDialog = true;
    },
    videoIndexChange: function videoIndexChange(index) {
      this.activeIndex = index;
      this.$bus.$emit('videoChange', this.intellectVideoList[index]);
    },
    switchTab: function switchTab() {
      // 切换分册
      this.$bus.$emit('toNextType');
    }
  }
};